module.exports = __webpack_public_path__ + "img/bnk3.1cb2dc4e.svg";